<template>
  <div class="kw-timepicker__list">
    <button
      type="button"
      class="kw-timepicker__arrow kw-timepicker__arrow_up"
      v-if="arrows"
      @click.prevent="moveList('up')"
    >
      <svgicon name="chevron-top"></svgicon>
    </button>
    <button
      type="button"
      class="kw-timepicker__arrow kw-timepicker__arrow_down"
      v-if="arrows"
      @click.prevent="moveList('down')"
    >
      <svgicon name="chevron" direction='up'></svgicon>
    </button>
    <ul ref="times" :style="listPosition('hours')">
      <li
        v-for="(time, index) in times"
        :key="index"
        :class="[{active: time === timeActive}, 'kw-timepicker__digit']"
      >
        <a href="#" @click.prevent="selectTimeHandler(time)">{{time}}</a>
      </li>
    </ul>
  </div>
</template>
<script>
import Svgicon from '@/components/UI/Svgicon.vue';

export default {
  components: {
    Svgicon,
  },
  props: {
    arrows: {
      type: Boolean,
      default: true,
    },
    scroll: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'hours',
    },
    times: Array,
    value: String,
    selectedTime: {
      type: String,
      default: '00',
    },
    includedTime: Array,
    excludedTime: Array,
    availableTime: Array,
  },
  data() {
    return {
      selectedVal: '00',
      draggingY: null,
      touched: false,
    };
  },
  computed: {
    value$: {
      get() { return this.value; },
      set(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },
    timeSelected() { return this.selectedTime; },
    timeActive() { return this.value$; },
  },
  methods: {
    selectTimeHandler(value) {
      this.select(value);
      this.$emit('close');
    },
    select(newVal, move = false) {
      const value = this.times.includes(newVal) ? newVal : this.times[0];
      if (move) {
        this.selectedVal = value;
      } else {
        this.value$ = value;
        this.selectedVal = value;
      }

      const { type } = this;
      this.$emit('change', { value, move, type });
    },
    moveList(direction) {
      let prevTime = '';
      let nextTime = '';
      let currentTime = '';
      currentTime = this.times.findIndex(item => item === this.timeSelected);
      prevTime = this.times[currentTime - 1];
      nextTime = this.times[currentTime + 1];
      if (direction === 'up') {
        if (this.value$) {
          if (currentTime > 0) {
            this.select(prevTime);
          }
        } else if (currentTime > 0) {
          this.select(prevTime, true);
        }
      } else if (direction === 'down') {
        if (this.value$) {
          if (currentTime >= 0 && (currentTime + 1) < this.times.length) {
            this.select(nextTime);
          }
        } else if (currentTime >= 0 && (currentTime + 1) < this.times.length) {
          this.select(nextTime, true);
        }
      }
    },
    listPosition() {
      const list = this.times;
      const current = this.timeSelected;

      const stepPercent = 100 / list.length;
      const elPosition = list.findIndex(item => item === current);

      return {
        transform: `translateY(${((stepPercent * 2) - (stepPercent * (elPosition >= 0 ? elPosition : 0)))}%)`,
      };
    },
    listScroll(e) {
      e.preventDefault();

      const delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));

      if (delta > 0) {
        this.moveList('up');
      } else {
        this.moveList('down');
      }
    },
    startDrag(e) {
      this.draggingY = e.changedTouches[0].pageY;
      this.touched = true;
    },
    doDrag(e) {
      e.preventDefault();
      if (this.draggingY < e.changedTouches[0].pageY) {
        if (this.draggingY + 25 < e.changedTouches[0].pageY) {
          this.moveList('up');
          this.draggingY = e.changedTouches[0].pageY;
        }
      } else if (this.draggingY - 25 > e.changedTouches[0].pageY) {
        this.moveList('down');
        this.draggingY = e.changedTouches[0].pageY;
      }
    },
  },
  watch: {
    value() {
      if (!this.times.includes(this.value) && this.value$) {
        this.select(this.times[0]);
      }
    },
    selectedTime() {
      if (!this.times.includes(this.selectedTime)) {
        this.select(this.times[0], !this.value$);
      }
      this.listPosition();
    },
    times() {
      if (!this.times.includes(this.selectedTime)) {
        this.select(this.times[0], !this.value$);
      }
      this.listPosition();
    },
  },
  mounted() {
    if (this.$el.addEventListener) {
      if ('onwheel' in document) {
        this.$el.addEventListener('wheel', this.listScroll);
      } else if ('onmousewheel' in document) {
        this.$el.addEventListener('mousewheel', this.listScroll);
      } else {
        this.$el.addEventListener('MozMousePixelScroll', this.listScroll);
      }
      this.$el.addEventListener('touchstart', this.startDrag);
      this.$el.addEventListener('touchmove', this.doDrag);

      if (!this.times.includes(this.selectedTime) && !this.value$) {
        this.select(this.times[0], true);
      }
    }
  },
  beforeDestroy() {
    if (this.$el.removeEventListener) {
      if ('onwheel' in document) {
        this.$el.removeEventListener('wheel', this.listScroll);
      } else if ('onmousewheel' in document) {
        this.$el.removeEventListener('mousewheel', this.listScroll);
      } else {
        this.$el.removeEventListener('MozMousePixelScroll', this.listScroll);
      }
      this.$el.removeEventListener('touchstart', this.startDrag);
      this.$el.removeEventListener('touchmove', this.doDrag);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UI/KwTimepicker/KwTimepickerSelect.vue